export const environment = {
    env: 'DEV',
    production: false,
    serverBaseUrl: 'https://api-dev.preplan.notifypetsatpeace.com',
    serverUrl: 'https://api-dev.preplan.notifypetsatpeace.com'
};
